import { LogoutCircle02Icon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import { IconButton } from '@pique/component';

import * as styles from './sidebar-header.css';

export type HeaderProps = {
  floating: boolean;
  onToggle?: () => void;
  children?: React.ReactNode;
  rightControls?: React.ReactNode;
};

function Container({
  children,
  style,
  className,
  floating,
}: {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  floating?: boolean;
}) {
  return (
    <div
      data-testid="header"
      style={style}
      className={className}
      data-sidebar-floating={floating}
      data-tauri-drag-region
    >
      {children}
    </div>
  );
}

const ToggleButton = ({ onToggle }: { onToggle?: () => void }) => {
  return (
    <IconButton
      size="20"
      onClick={onToggle}
      data-tauri-drag-region="false"
    >
      <HugeiconsIcon icon={LogoutCircle02Icon} size={16} />
    </IconButton>
  );
};

export const Header = ({
  floating,
  children,
  onToggle,
  rightControls,
}: HeaderProps) => {
  return (
    <Container className={styles.header} floating={floating}>
      {children}
      <div className={styles.spacer} />
      {rightControls}
      <ToggleButton onToggle={onToggle} />
    </Container>
  );
};
